const BASE = "https://creationarts.com";

/**
 * LocalBusiness JSON-LD, injected on every page by <SEO />.
 * Address, phones, hours and map pin come from the same data the footer and
 * contact page display (the coordinates are the centre of the footer's Google
 * Maps embed for the Musaffah address).
 */
export const localBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${BASE}/#organization`,
  name: "Creation Arts For Flags and Digital Printing LLC",
  alternateName: [
    "Creation Arts",
    "فنون الإبداع للأعلام والطباعة الرقمية ذ.م.م",
  ],
  description:
    "One of the world's largest flag manufacturing facilities. Custom flags, flagpoles, banners, lanyards, stickers, badges, and apparel for governments, corporations, and events worldwide.",
  url: `${BASE}/`,
  logo: `${BASE}/dark.png`,
  image: `${BASE}/creation-arts-flags-banner.png`,
  telephone: "+97124492990",
  email: "connect@creationarts.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "M32 Plot 7, Building 28, Musaffah Industrial Area",
    addressLocality: "Abu Dhabi",
    addressRegion: "Abu Dhabi",
    addressCountry: "AE",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 24.353776,
    longitude: 54.506532,
  },
  hasMap: "https://maps.app.goo.gl/XT6JMPxLMDSXbGFr7",
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday"],
      opens: "10:00",
      closes: "19:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Friday",
      opens: "16:00",
      closes: "19:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Saturday",
      opens: "11:00",
      closes: "17:00",
    },
  ],
  areaServed: { "@type": "Place", name: "Worldwide" },
  sameAs: ["https://www.instagram.com/creationartsuae/?hl=en"],
});
